export const TEST_CONFIG = {
  AUTO_SAVE_INTERVAL: 2000,      // Auto-save progress every 2 seconds
  PROGRESS_EXPIRY: 3600000,      // Delete saved progress after 1 hour
  TIMER_UPDATE_INTERVAL: 250     // Update timer display every 250ms
};
